import moment from 'moment';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import ColoredHeader from '../../../common/components/layout/ColoredHeader';
import MandatoryInput from '../../../common/components/layout/MandatoryInput';
import {flowRight as compose} from 'lodash';
import {withLoadedUser} from '../../../login/containers/AuthBase';
import InputCol, {AttributeDiv} from '../../../common/components/layout/InputCol';
import ProfileFooter from './ProfileFooter';
import {useMutation} from '@apollo/react-hooks';
import {GRAPHQL_MUTATION_UPDATE_USER_OR_ADMIN} from '../../../common/queries/users';
import SelectCivility from '../../../common/components/User/SelectCivility';

const RowNoMargin = styled(Row)`
  &&{
    margin-left: 0;
    margin-right: 0;
  }
`;

const ProfileUser = ({t, showSuccess, showError, currentUser}) => {
  const {id, firstName, lastName, createdAt, email, street, city, postalCode, mobilePhone, civility, birthDate} = currentUser;
  const [mutation, {loading}] = useMutation(GRAPHQL_MUTATION_UPDATE_USER_OR_ADMIN);
  const [user, setUser] = useState({id, firstName, lastName, street, city, postalCode, mobilePhone, civility, birthDate});
  const [submitted, setSubmitted] = useState(false);

  const onChange = (name, value) => {
    setUser({...user, [name]: value});
  };

  const onSubmit = () => {
    setSubmitted(true);
    if (user.firstName && user.lastName && user.postalCode) {
      const variables = {
        userInput: user,
      };
      mutation({variables})
        .then(() => {
          showSuccess();
        })
        .catch(() => {
          showError();
        });
    }
  };

  return (
    <>
      <Row className="section-info row">
        <ColoredHeader>{firstName + ' ' + lastName}</ColoredHeader>
        <Col xs={6}>
          <RowNoMargin>
            <MandatoryInput
              title={`${t('dataTable.firstname')} : `}
              name="firstName"
              value={user.firstName}
              onChange={onChange}
              show={user.firstName === '' && submitted}
            />
            <MandatoryInput
              title={`${t('dataTable.lastname')} : `}
              name="lastName"
              value={user.lastName}
              onChange={onChange}
              show={user.lastName === '' && submitted}
            />
            <InputCol
              title={`${t('street')} : `}
              size={12}
              name="street"
              onChange={onChange}
              value={user.street || ''} />
          </RowNoMargin>
          <RowNoMargin>
            <MandatoryInput
              title={`${t('mobilePhone')} : `}
              name="mobilePhone"
              value={user.mobilePhone}
              onChange={onChange}
              show={user.mobilePhone === '' && submitted}
              disabled
            />
          </RowNoMargin>
        </Col>
        <Col xs={6}>
          <RowNoMargin>
            <InputCol
              title={`${t('dataTable.creation')} : `}
              size={12}
              name="creation"
              value={moment(createdAt).format('DD/MM/YYYY')}
              disabled />
            <InputCol
              title={`${t('dataTable.email')} : `}
              size={12}
              name="email"
              value={email}
              disabled />
            <InputCol
              title={`${t('city')} : `}
              size={8}
              name="city"
              onChange={onChange}
              value={user.city || ''} />
            <MandatoryInput
              title={`${t('postalCode')} : `}
              name="postalCode"
              size={4}
              value={user.postalCode || ''}
              onChange={onChange}
              show={user.postalCode === '' && submitted} />
          </RowNoMargin>
          <RowNoMargin>
            <MandatoryInput
              name="birthDate"
              type="date"
              title={t('birthDate')}
              value={user.birthDate}
              onChange={onChange}
              show={user.birthDate === '' && submitted}
              size={8}
            />
            <Col xs={4}>
              <label>
                <AttributeDiv className="label-name">{t('dataTable.civility')}</AttributeDiv>
                <SelectCivility
                  value={user.civility}
                  onChange={e => setUser({...user, civility: e.target.value})}/>
              </label>
            </Col>
          </RowNoMargin>
        </Col>
      </Row>
      <ProfileFooter onClick={onSubmit} loading={loading}/>
    </>
  );
};

ProfileUser.propTypes = {
  t: PropTypes.func.isRequired,
  submitted: PropTypes.bool,
  showSuccess: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
};

export default compose(
  withLoadedUser,
  withTranslation('user'),
)(ProfileUser);
